/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React, { useState, useRef } from 'react';
import './Accordion.css';

function Accordion(props) {
  const [setActive, setActiveState] = useState(props.defaultOpen ? 'active' : '');
  const [setHeight, setHeightState] = useState(props.defaultOpen ? props.height || 'max-content' : '0px');
  const [setRotate, setRotateState] = useState(props.defaultOpen ? 'accordion-icon rotate' : 'accordion-icon');
  const {
    containerClass = '',
    dropdownIcon = false,
    dropDownOpen = '-',
    iconPosition = 'left',
    addBefore,
    addAfter,
    IsFontInherit,
    contentClass,
    isJXSContent,
    height
  } = props;

  const content = useRef(null);

  function toggleAccordion() {
    const state = setActive === '' ? 'active' : '';
    setActiveState(state);
    setHeightState(state === '' ? '0px' : height || `${content.current.scrollHeight}px`);
    setRotateState(setActive === 'active' ? 'accordion-icon' : 'accordion-icon rotate');
  }

  return (
    <div className={`accordion-section ${containerClass}`}>
      {iconPosition === 'left' && (
        <div className={`accordion ${setActive} tw-gap-5`} onClick={toggleAccordion}>
          {!dropdownIcon ? (
            <i className={`fa fa-chevron-right va-sub title-text-color arrow-golden ${setRotate}`} aria-hidden="true" />
          ) : (
            <div>{setActive === 'active' ? dropDownOpen : dropdownIcon}</div>
          )}
          <p
            className={`accordion-title ${contentClass} text-capitalize mb-0 ${!IsFontInherit ? 'font-universe' : ''}`}
          >
            {props.title}
          </p>
        </div>
      )}
      {iconPosition === 'right' && (
        <div className={`accordion ${setActive} icon-right tw-gap-5`} onClick={toggleAccordion}>
          <p
            className={`accordion-title ${contentClass} text-capitalize mb-0 ${!IsFontInherit ? 'font-universe' : ''}`}
          >
            {props.title}
          </p>
          {!dropdownIcon ? (
            <i className={`fa fa-chevron-right va-sub title-text-color arrow-golden ${setRotate}`} aria-hidden="true" />
          ) : (
            <div>{setActive === 'active' ? dropDownOpen : dropdownIcon}</div>
          )}
        </div>
      )}
      <div
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className={`accordion-content mb-0 d-lg-flex ${!IsFontInherit ? 'font-universe' : ''}`}
      >
        {!isJXSContent ? (
          <div>
            {addBefore}
            <div className="accordion-text" dangerouslySetInnerHTML={{ __html: props.content }} />
            <p className="contact color-grey">
              <a href={props.href} target="_blank" rel="noreferrer">
                {props.contact}
              </a>
              {addAfter}
            </p>
          </div>
        ) : (
          <>{props.content}</>
        )}
        {props.asset && <div>{props.asset}</div>}
      </div>
    </div>
  );
}

export default Accordion;
